import React from 'react';
import styles from './chip.scss';

const Chip = ({
  label,
  onDelete,
  variant = 'filled',
  color = 'default',
  onClick = null,
  csx = { wrapper: {} }
}) => {
  return (
    <div
      className={`${styles.chip} ${styles[`chip--${variant}`]} ${
        styles[`chip--${color}`]
      }`}
      onClick={onClick}
      style={csx.wrapper}
    >
      <span className={styles['chip-label']}>{label}</span>
      {onDelete && (
        <span className={styles['chip-delete']} onClick={onDelete}>
          &times;
        </span>
      )}
    </div>
  );
};

export default Chip;
